import React, { useState } from 'react';
import '../../entrydoor.css';

const SubFrame = ({ value, onChange, label = 'Sub Frame:', disabled = false }) => {
    const [selectedSubFrame, setSelectedSubFrame] = useState(value || 'Yes');

    const handleSubFrameChange = (e) => {
        setSelectedSubFrame(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="SubFrame">{label}</label>
            <select 
                disabled={disabled}
                id="SubFrame"
                value={selectedSubFrame}
                onChange={handleSubFrameChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value='Yes'>{selectedSubFrame === 'Yes' ? 'Yes" ✔' : 'Yes'}</option>
                <option value='No'>{selectedSubFrame === 'No' ? 'No ✔' : 'No'}</option>
            </select>
        </div>
    );
};

export default SubFrame;
